// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quota {\r\n  text-align: center;\r\n  padding-top: 16px;\n}\n.big {\r\n  font-size: 48px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
